module.exports = __webpack_public_path__ + "img/320.03c7abc4.jpg";